// import NewsroomListing from "./NewsroomListing.jsx";
// import { PRESS_RELEASES } from "../data/News.js";

// /**
//  * ASSOCHAM — Newsroom / Press Release
//  * Official statements, announcements and communiqués.
//  */
// export default function PressRelease() {
//   return (
//     <NewsroomListing
//       // eyebrow="Official Communiqués"
//       titleA="Press"
//       titleB="Releases"
//       // description="Every official word from the chamber — statements on policy, signed partnerships, conclave outcomes and research launches, straight from the ASSOCHAM media desk in New Delhi."
//       items={PRESS_RELEASES}
//       // listTitle="Press Release"
//       showSource={false}
//     />
//   );
// }




// new new code 




import { useEffect, useState } from "react";
import NewsroomListing from "./NewsroomListing.jsx";
import { fetchPressReleases } from "./pressReleaseApi.js";

export default function PressRelease() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let alive = true;
    fetchPressReleases()
      .then((data) => alive && setItems(data))
      .catch((err) => alive && setError(err.message))
      .finally(() => alive && setLoading(false));
    return () => { alive = false; };
  }, []);

  if (loading) {
    return (
      <div className="min-h-[60vh] grid place-items-center bg-cream">
        <p className="text-[13px] font-bold text-mute animate-pulse">Loading press releases…</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-[60vh] grid place-items-center bg-cream">
        <p className="text-[13px] font-bold text-brand">Couldn't load press releases: {error}</p>
      </div>
    );
  }

  if (items.length === 0) {
    return (
      <div className="min-h-[60vh] grid place-items-center bg-cream">
        <p className="text-[13px] font-bold text-mute">No press releases found.</p>
      </div>
    );
  }

  return (
    <NewsroomListing
      titleA="Press"
      titleB="Releases"
      items={items}
      showSource={false}
    />
  );
}